import React, { useState } from "react"
import { Edit } from "react-feather"
import { useProfile } from "../contexts/ProfileContextProvider"
import Header from "../components/LayoutComponents/Header"
import AnimatedChili from "../components/AnimatedChili/AnimatedChili"
import CookiePrompt from "../components/CookiePrompt/CookiePrompt"
import { AnimatePresence } from "framer-motion"
import ThemeToggle from "../components/ProfileComponents/ThemeToggle"
import CookieToggle from "../components/ProfileComponents/CookieToggle"
import SocialLinks from "../components/ProfileComponents/SocialLinks"
import ModalWrapper from "../components/LayoutComponents/ModalComponent/ModalWrapper"

function Profile() {
    const {
        contextSetHasOnBoarded,
        profileData,
        contextSetHasAllowedCookies,
        hasAllowedCookies,
        favorites,
        contextClearFavorites,
    } = useProfile()

    const resetOnboardingModal = () => {
        contextSetHasOnBoarded(false)
    }

    const [showCookiePrompt, setShowCookiePrompt] = useState(false)
    const [showClearFavorites, setShowClearFavorites] = useState(false)

    return (
        <div className="w-full pb-safe-nav bg-neutral-100 dark:bg-neutral-900">
            <div className="bg-color-1">
                <Header text={"Din Profil"} />
            </div>

            <div className="px-4  bg-gradient-to-b from-white to-neutral-100 dark:from-neutral-900 dark:to-neutral-900">
                <div className="flex max-w-2xl mx-auto">
                    <div className="mx-auto flex flex-col items-center space-y-2">
                        <div className="flex items-center justify-center bg-neutral-800 rounded-full size-24 shadow-lg">
                            <span className="text-4xl text-white font-semibold">
                                {profileData.name ? (
                                    profileData.name[0].toUpperCase()
                                ) : (
                                    <AnimatedChili classes={"size-16 mb-3"} />
                                )}
                            </span>
                        </div>
                        <span className="text-2xl font-semibold fg-color-1">
                            {profileData.name ? profileData.name : "Hotspot"}
                        </span>
                    </div>
                </div>
            </div>

            <div className="bg-neutral-100 dark:bg-neutral-900 p-4 divide-y divide-neutral-200 dark:divide-neutral-800 *:py-8">
                <div className="fg-color-1  rounded-lg space-y-4 max-w-2xl mx-auto">
                    <div className="flex justify-between items-end">
                        <h2 className="font-bold text-lg xl mb-2 leading-3">
                            Mina Preferenser
                        </h2>
                        <button
                            onClick={resetOnboardingModal}
                            className="flex gap-2 items-center text-lg rounded underline"
                        >
                            Ändra
                            <Edit size={18} strokeWidth={1.5} />
                        </button>
                    </div>

                    {profileData.branscher.length > 0 && (
                        <div>
                            <h2 className="font-semibold  mb-2">Branscher</h2>
                            <div className="flex flex-wrap gap-2 text-sm">
                                {profileData.branscher.map((b, index) => (
                                    <>
                                        <div
                                            key={index}
                                            className="bg-neutral-200 dark:bg-neutral-800 rounded px-4 py-2"
                                        >
                                            {b}
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    )}
                    {profileData.tjanster.length > 0 && (
                        <div>
                            <h2 className="font-semibold xl mb-2">Tjänster</h2>
                            <div className="flex flex-wrap gap-2 text-sm">
                                {profileData.tjanster.map((t, index) => (
                                    <>
                                        <div
                                            key={index}
                                            className="bg-neutral-200 dark:bg-neutral-800 rounded px-4 py-2"
                                        >
                                            {t}
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    )}
                    {!profileData.branscher.length &&
                        !profileData.tjanster.length && (
                            <p>Inga preferenser valda just nu...</p>
                        )}
                </div>

                <div className="max-w-2xl mx-auto space-y-4 fg-color-1 ">
                    <h2 className="font-bold text-lg xl mb-2 ">
                        Andra Inställningar
                    </h2>

                    <ThemeToggle hasAllowedCookies={hasAllowedCookies} />
                    <AnimatePresence>
                        <CookieToggle
                            key={"abc"}
                            hasAllowedCookies={hasAllowedCookies}
                            setShowCookiePrompt={setShowCookiePrompt}
                        />
                    </AnimatePresence>
                </div>

                {favorites?.length > 0 && (
                    <div className="max-w-2xl mx-auto space-y-4 fg-color-1">
                        <h2 className="font-bold text-lg xl mb-2 ">
                            Favoriter
                        </h2>
                        <div className="space-y-2">
                            <p className="fg-color-2">
                                {favorites.length}{" "}
                                {favorites.length === 1
                                    ? "Favorit sparad"
                                    : "Favoriter sparade"}
                            </p>
                            <button
                                className="underline text-primary-500"
                                onClick={() => setShowClearFavorites(true)}
                            >
                                Rensa Favoriter
                            </button>
                        </div>
                        {showClearFavorites && (
                            <>
                                <ModalWrapper
                                    onClick={() => setShowClearFavorites(false)}
                                >
                                    <div className="flex items-center justify-center h-full cursor-pointer">
                                        <div
                                            onClick={(e) => e.stopPropagation()}
                                            className="bg-white cursor-auto dark:bg-neutral-800 p-4 place-content-center rounded-lg max-w-md mx-auto"
                                        >
                                            <h2 className="font-bold fg-color-1 text-lg mb-2">
                                                Rensa Favoriter?
                                            </h2>
                                            <p className="fg-color-2">
                                                Är du säker på att du vill rensa
                                                dina favoriter?
                                            </p>
                                            <div className="flex gap-4 mt-4">
                                                <button
                                                    className="flex-1 bg-primary-500 text-white font-semibold rounded-lg py-2"
                                                    onClick={() =>
                                                        setShowClearFavorites(
                                                            false,
                                                        )
                                                    }
                                                >
                                                    Nej
                                                </button>
                                                <button
                                                    className="flex-1 bg-neutral-800 font-semibold text-white dark:text-neutral-900 dark:bg-neutral-200 rounded-lg py-2"
                                                    onClick={() => {
                                                        contextClearFavorites()
                                                        setShowClearFavorites(
                                                            false,
                                                        )
                                                    }}
                                                >
                                                    Ja
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </ModalWrapper>
                            </>
                        )}
                    </div>
                )}

                <div className="max-w-2xl mx-auto space-y-4 fg-color-1">
                    <h2 className="font-bold text-lg xl mb-2 ">Våra länkar</h2>
                    <SocialLinks />
                </div>
            </div>

            {
                <div className="fixed inset-x-0 bottom-0 h-full bg-neutral-100 dark:bg-neutral-900 -z-10"></div>
            }

            {showCookiePrompt && (
                <AnimatePresence mode="wait">
                    <CookiePrompt
                        key={"cookiePrompt"}
                        onAccept={() => {
                            contextSetHasAllowedCookies(true)
                            setShowCookiePrompt(false)
                        }}
                        onDecline={() => {
                            contextSetHasAllowedCookies(false)
                            setShowCookiePrompt(false)
                        }}
                        visible={true}
                    />
                </AnimatePresence>
            )}
        </div>
    )
}

export default Profile
